<template>
  <article id="article-check-auth">
    <section id="section-check-auth">
      <div class="image-auth">
        <i class="fas fa-user"></i>
      </div>
      <div class="content-auth">
        <div class="title">กรุณาสมัครสมาชิก</div>
        <div class="title">หรือเข้าสู่ระบบ FINNOMENA</div>
        <div class="sub-title">เพื่อเริ่มติดตามสินทรัพย์</div>
      </div>
      <a
        data-action="register_or_login_following"
        class="button-auth"
        href="javascript:;"
        @click="redirectToAuth()"
      >สมัครสมาชิก/เข้าสู่ระบบ</a>
    </section>
  </article>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("onboarding", ["getLineID"])
  },
  methods: {
    redirectToAuth() {
      const uid = this.uid()
      let return_url = this.$route.fullPath;
      window.location.replace(`/login?return_url=${encodeURIComponent(return_url)}&uid=${uid}`)
    },
    uid() {
      return this.getLineID || ""
    }
  }
};
</script>

<style lang="scss" scoped>
#article-check-auth {
  #section-check-auth {
    @extend %container-style;
    margin-top: 96px;
    text-align: center;
    .image-auth {
      text-align: center;
      width: 67px;
      height: 67px;
      margin: auto;
      background-color: #d8d8d8;
      border-radius: 50%;
      i {
        margin: 12px 0;
        font-size: 40px;
        color: #fdfdfd;
      }
    }
    .content-auth {
      margin: 18px 0;
      .title {
        @extend %font-size-m;
        font-weight: bold;
        color: $color-normal-text;
      }
      .sub-title {
        @extend %font-size-s;
        color: $color-normal-text;
      }
    }
    .button-auth {
      @include finRippleBtn($color-primary-finno, $color-primary-finno, $color-normal-text);
      @extend %font-size-ss;
      padding: 11px 25px;
      text-decoration: none;
      font-weight: bold;
      border-radius: 4px;
      display: inline-block;
    }
  }
}
</style>